import { Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../context/authProvider";
import SideNav from "./SideNav";

const BASE_LINKS = [
    { to: "/manafix", label: "Início", end: true },
    { to: "/manafix/users", label: "Usuários" },
    { to: "/manafix/products", label: "Pedidos" },
    { to: "/manafix/stores", label: "Lojas" },
    { to: "/manafix/transactions", label: "Transações" },
    { to: "/manafix/gradable-models", label: "Modelos" },
    // `end`: Seriais não pode acender junto com Etiquetas (/manafix/serials/tags).
    { to: "/manafix/serials", label: "Seriais", end: true },
    { to: "/manafix/serials/tags", label: "Etiquetas" },
    { to: "/manafix/art-labels", label: "Artes" },
    { to: "/manafix/coupons", label: "Cupons" },
    { to: "/manafix/feriados", label: "Feriados" },
];
const MASTER_LINKS = [
    { to: "/manafix/logs", label: "Logs" },
    { to: "/manafix/presentations", label: "Apresentações" },
];
const TAIL_LINKS = [
    { to: "/manafix/status", label: "Fluxos Status" },
    { to: "/manafix/bot-ops", label: "Bot Ops" },
];

const Layout = () => {
    const { user, logout } = useContext(AuthContext);
    const links = [...BASE_LINKS, ...(user.roles.includes("master") ? MASTER_LINKS : []), ...TAIL_LINKS];

    return (
        <div className="flex min-h-screen text-orange-100">
            <SideNav home="/manafix" links={links} user={user} onLogout={logout} />
            <div className="min-w-0 flex-1"><Outlet /></div>
        </div>
    );
};

export default Layout;
